import React, { useState } from 'react';
import { useAuth } from '../../systems/auth-context';
import DepartmentPicker from './DepartmentPicker';
import styles from './auth.module.css';

interface RegisterUserProps {
  onSwitchToLogin: () => void;
}

const RegisterUser: React.FC<RegisterUserProps> = ({ onSwitchToLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [department, setDepartment] = useState('');
  const [adminCode, setAdminCode] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccessMessage(null);

    try {
      const payload: { email: string; password: string; admin_code?: string; department: string } = {
        email,
        password,
        department,
      };
      if (adminCode.trim()) payload.admin_code = adminCode.trim();

      const response = await fetch('/api/auth/register-user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Inscription échouée');
      }

      if (data.activated && data.user) {
        login(data.user);
      } else {
        setSuccessMessage(
          data.message || 'Compte créé. Un administrateur doit activer votre compte avant que vous puissiez vous connecter.'
        );
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className={styles.authContainer}>
      <h2>Créer un compte</h2>
      <p className={styles.description}>
        Créez un compte pour accéder aux scénarios. Si votre email est sur liste blanche, vous serez activé automatiquement. Sinon, un administrateur activera votre compte.
      </p>
      {error && <div className={styles.error}>{error}</div>}
      {successMessage && <div className={styles.success}>{successMessage}</div>}
      <form onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label>Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>
        <div className={styles.inputGroup}>
          <label>Mot de passe</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <DepartmentPicker value={department} onChange={setDepartment} />
        <div className={styles.inputGroup}>
          <label>Code entreprise (optionnel)</label>
          <input 
            type="text" 
            value={adminCode} 
            onChange={(e) => setAdminCode(e.target.value)} 
            placeholder="Ex: ABC123"
          />
        </div>
        <button type="submit" className={styles.submitBtn}>S'inscrire</button>
      </form>
      <div className={styles.securityInfo}>
        L'utilisation d'un gestionnaire de mots de passe comme <strong>Proton Pass</strong> permet de créer des comptes plus sécurisés et de protéger votre vie privée.
      </div>
      <div className={styles.switchLinks}>
        <button onClick={onSwitchToLogin} className={styles.linkBtn}>
          Déjà un compte ? Se connecter
        </button>
      </div>
    </div>
  );
};

export default RegisterUser;
